import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getIncludance,
  getProspectid,
  changeSelectedWithOtherDispatches,
} from "../store/quotes";
import { getBrokerInformation } from "../store/broker";
import { LoadingLine } from "./LoadingLine";
import * as theme from "../theme";
import CloudDoneIcon from "@material-ui/icons/CloudDone";
import CloudQueueIcon from "@material-ui/icons/CloudQueue";
import WarningIcon from "@material-ui/icons/Warning";
import { PossibleIncludanceValues } from "../store/helperfuncs";
import { changeHelpOrTipText } from "../store/components";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import WbCloudyIcon from "@material-ui/icons/WbCloudy";

// Helper function to get translations based on language code
const getTranslations = (languagecode) => {
  const translations = {
    en: {
      includedInPast: "This insurer was already included in Insurers Hub for this prospect",
      includedThisTime: "This insurer was just included in Insurers Hub of this prospect",
      neverIncluded: "This insurer was never included in the Insurers Hub, please select once to get it included",
      deselect: "Deselect this insurer",
      select: "Select this insurer. This will also add this insurer to the Insurers Hub.",
    },
    fr: {
      includedInPast: "Cet assureur a déjà été inclus dans le Hub Assureurs pour ce prospect",
      includedThisTime: "Cet assureur vient d'être inclus dans le Hub Assureurs pour ce prospect",
      neverIncluded: "Cet assureur n'a jamais été inclus dans le Hub Assureurs, veuillez le sélectionner une fois pour l'inclure",
      deselect: "Désélectionner cet assureur",
      select: "Sélectionner cet assureur. Cela ajoutera également cet assureur au Hub Assureurs.",
    },
  };
  return translations[languagecode] || translations.en;
};

const IncludanceAndSelection = (props) => {
  const { code } = props;

  const dispatch = useDispatch();
  const includance = useSelector(
    (state) => state.entities.quotes.insurerdetails[code]["includance"]
  );

  const prospectid = useSelector(getProspectid);

  // decide between 6 possible values of includance
  const DivDecider = () => {
    if (includance === PossibleIncludanceValues.awaiting) {
      return <AwaitingIncludance></AwaitingIncludance>;
    } else if (includance === PossibleIncludanceValues.failed) {
      return <WarningIconMUI></WarningIconMUI>;
    } else if (
      includance === PossibleIncludanceValues.neverincluded ||
      includance === PossibleIncludanceValues.includedinpast ||
      includance === PossibleIncludanceValues.incudedthistime
    ) {
      return (
        <div>
          <CloudAndSelector
            includance={includance}
            code={code}
          ></CloudAndSelector>
        </div>
      );
    } else {
      return <div>-</div>;
    }
  };
  useEffect(() => {
    if (includance === PossibleIncludanceValues.nullvalue) {
      //dispatch(getIncludance({ prospectid, insurercode: code }));
    }
  }, [dispatch, includance, code, prospectid]);

  return <div style={{ width: "100%" }}>{DivDecider()}</div>;
};

const AwaitingIncludance = (props) => {
  return (
    <LoadingLine
      type={"bubbles"}
      color={theme.COLORS.primary_navyblue}
    ></LoadingLine>
  );
};

const WarningIconMUI = (props) => {
  return (
    <WarningIcon
      style={{ color: theme.COLORS.warning_color }}
      onMouseOver={() => {}}
    ></WarningIcon>
  );
};

const IncludedInPastIcon = (props) => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const t = getTranslations(languagecode);

  return (
    <div
      onMouseOver={() => {
        dispatch(changeHelpOrTipText(t.includedInPast));
      }}
      onMouseOut={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    >
      <WbCloudyIcon
        style={{
          color: theme.COLORS.dark_green_dot,
          fontSize: theme.SCALES.cloudIconSize,
        }}
      ></WbCloudyIcon>
    </div>
  );
};

const IncludedThisTimeIcon = (props) => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const t = getTranslations(languagecode);

  return (
    <CloudDoneIcon
      style={{
        color: theme.COLORS.dark_green_dot,
        fontSize: theme.SCALES.cloudIconSize,
      }}
      onMouseOver={() => {
        dispatch(changeHelpOrTipText(t.includedThisTime));
      }}
      onMouseOut={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    ></CloudDoneIcon>
  );
};

const NeverIncludedIcon = (props) => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const t = getTranslations(languagecode);

  return (
    <CloudQueueIcon
      style={{
        color: theme.COLORS.grey_font_header,
        fontSize: theme.SCALES.cloudIconSize,
      }}
      onMouseOver={() => {
        dispatch(changeHelpOrTipText(t.neverIncluded));
      }}
      onMouseOut={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    ></CloudQueueIcon>
  );
};

const SelectedIcon = (props) => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const t = getTranslations(languagecode);

  return (
    <CheckBoxIcon
      style={{
        color: theme.COLORS.grey_font_header,
        fontSize: theme.SCALES.selectedNotSelectedIcon,
      }}
      onMouseOver={() => {
        dispatch(changeHelpOrTipText(t.deselect));
      }}
      onMouseOut={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    ></CheckBoxIcon>
  );
};

const NotSelectedIcon = (props) => {
  const dispatch = useDispatch();
  const brokerage = useSelector(getBrokerInformation);
  const languagecode = brokerage.information.languagepreference;
  const t = getTranslations(languagecode);

  return (
    <CheckBoxOutlineBlankIcon
      style={{
        color: theme.COLORS.grey_font_header,
        fontSize: theme.SCALES.selectedNotSelectedIcon,
      }}
      onMouseOver={() => {
        dispatch(changeHelpOrTipText(t.select));
      }}
      onMouseOut={() => {
        dispatch(changeHelpOrTipText(""));
      }}
    ></CheckBoxOutlineBlankIcon>
  );
};

const CloudAndSelector = ({ includance, code }) => {
  const selected = useSelector(
    (state) => state.entities.quotes.insurerdetails[code].selected
  );

  const dispatch = useDispatch();

  const DivDecider = () => {
    if (includance === PossibleIncludanceValues.neverincluded) {
      return <NeverIncludedIcon></NeverIncludedIcon>;
    }

    if (includance === PossibleIncludanceValues.includedinpast) {
      return <IncludedInPastIcon></IncludedInPastIcon>;
    }

    if (includance === PossibleIncludanceValues.incudedthistime) {
      return <IncludedThisTimeIcon></IncludedThisTimeIcon>;
    }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        padding: "25%",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>{DivDecider()}</div>
      <div
        style={{ cursor: "pointer" }}
        onClick={() => {
          dispatch(changeSelectedWithOtherDispatches({ code }));
        }}
      >
        {selected ? (
          <SelectedIcon></SelectedIcon>
        ) : (
          <NotSelectedIcon></NotSelectedIcon>
        )}
      </div>
    </div>
  );
};

export default IncludanceAndSelection;
